import React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle, LinearProgress, Dialog, Typography, DialogContentText } from '@mui/material';

export interface ConfirmDeleteDialogProps {
    onConfirm: () => Promise<string[] | undefined>;
    onCancel?: () => void;
    message: string;
    title: string;
}

export function ConfirmDeleteDialog(props: ConfirmDeleteDialogProps) {
    const [errors, setErrors] = React.useState<string[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);

    function handleCancel() {
        if (props.onCancel) {
            props.onCancel();
        }
    }

    async function handleConfirm() {
        setLoading(true);
        const confirmErrors = await props.onConfirm();
        setLoading(false);
        if (confirmErrors) {
            setErrors(confirmErrors);
        }
    }

    return (
        <Dialog open={true} fullWidth>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
                {errors && errors.map(error => (
                    <Typography key={error} variant="body1" color="error">
                        {error}
                    </Typography>
                ))}
                {errors && errors.length > 0 && <br />}
                {loading === true && <LinearProgress />}
                <DialogContentText>
                    {props.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleConfirm} color="error" disabled={loading}>
                    Delete
                </Button>
                <Button onClick={handleCancel} color="primary" disabled={loading}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>)
}